<script setup lang="ts">
import MarketingFlowTriggerTypeBaseWrap from './BaseWrap.vue'

import type { TriggerSettings } from '../../types/marketingFlow'

const { t } = useI18n()
const triggerSettings = defineModel<TriggerSettings>('triggerSettings')

defineEmits<{
  (e: 'onChanges', change: { isCritical: boolean; field?: string; value?: any }): void
}>()

const dateRelativeOffsetDaysString = computed({
  get: () => String(triggerSettings.value?.dateRelativeOffsetDays ?? 0),
  set: (v: string) => {
    if (triggerSettings.value) {
      triggerSettings.value.dateRelativeOffsetDays = Number(v)
    }
  }
})

const options = computed(() => {
  const baseOptions = [
    {
      label: t('pages.marketingFlow.marketingFlowEditPage.trigger.birthdayOffsetValues.today'),
      value: 0
    },
    {
      label: t('pages.marketingFlow.marketingFlowEditPage.trigger.birthdayOffsetValues.yesterday'),
      value: 1
    }
  ]

  const daysOptions = Array.from({ length: 9 }, (_, i) => ({
    label: t('pages.marketingFlow.marketingFlowEditPage.trigger.birthdayOffsetValues.daysBefore', {
      days: i + 2
    }),
    value: i + 2
  }))

  return [...baseOptions, ...daysOptions]
})
</script>

<template>
  <MarketingFlowTriggerTypeBaseWrap
    icon="IconoirCalendarCheck"
    :title="t('pages.marketingFlow.marketingFlowEditPage.trigger.birthdayOffset')"
  >
    <Select
      v-model="dateRelativeOffsetDaysString"
      @update:model-value="
        $emit('onChanges', { isCritical: true, field: 'dateRelativeOffsetDays', value: Number($event) })
      "
    >
      <SelectTrigger class="h-10 w-full">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem v-for="option in options" :key="option.value" :value="String(option.value)">
          {{ option.label }}
        </SelectItem>
      </SelectContent>
    </Select>
  </MarketingFlowTriggerTypeBaseWrap>
</template>
